/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetNewbuildingDeveloperValuationRequest,
  TGetNewbuildingDeveloperValuationModel,
  IMappers,
  TGetNewbuildingDeveloperValuationResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingDeveloperValuationResponse } from '../../entities/newbuilding_developer_valuation/GetNewbuildingDeveloperValuationResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNewbuildingDeveloperValuationModel(
  parameters: TGetNewbuildingDeveloperValuationRequest,
): TGetNewbuildingDeveloperValuationModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-estimate',
    pathApi: '/v1/get-newbuilding-developer-valuation/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetNewbuildingDeveloperValuationOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetNewbuildingDeveloperValuationRequest;
}

export async function fetchGetNewbuildingDeveloperValuation<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingDeveloperValuationOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNewbuildingDeveloperValuationResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingDeveloperValuationModel(parameters),
    config,
  )) as FetchResponse<TGetNewbuildingDeveloperValuationResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingDeveloperValuationResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingDeveloperValuationResponse>;
}
